type OneVerseRole = { role?: string } | string;

export function hasMasterAdminRole(oneVerseRoles?: OneVerseRole[] | null) {
    return (
        oneVerseRoles?.some((oneVerseRole) => {
            if (typeof oneVerseRole === 'string') {
                return oneVerseRole === 'masterAdmin';
            }

            return oneVerseRole?.role === 'masterAdmin';
        }) ?? false
    );
}

type CanShowAdminEntryInput = {
    hasAdminAccess: boolean;
    hasAdminFlag?: boolean;
};

export function canShowAdminEntry({ hasAdminAccess, hasAdminFlag = true }: CanShowAdminEntryInput) {
    return hasAdminFlag && hasAdminAccess;
}
